import lookup from './water_use_lookup.json';
import getCropName from './cropNameLookup';

export default function getTypicalYield(crop, values, language) {
  const weatherStation =
    values.weatherStation[0].toUpperCase() + values.weatherStation.slice(1);
  const soilCode = values.soilCode.toString();
  const cropName = language !== 'en' ? getCropName(language, crop) : crop;
  const lookupValues = lookup[weatherStation][soilCode][cropName];
  let cropYield = lookupValues['Typical Crop Yield (tonnes/ha)'];

  if (values.landAvailableUnit === 'ha') {
    cropYield = cropYield * 1000; // convert to kg per hectare
  } else {
    cropYield = cropYield * 1000 * (1 / 3); // convert to kg per topos
  }

  return cropYield.toFixed(0);
}
